<template>
  <div>
    <ul class="imagebox-list" ref="images">
      <li class="imagebox-list-item" v-for="image in images" :key="image.id">
        <figure class="imagebox">
          <a
            :href="image.imagePath" 
            :data-size="`${image.width}x${image.height}`" 
            class="imagebox-content"
          >
            <img :src="image.imagePath" :alt="image.name" />
          </a>
          <figcaption class="imagebox-footer">
            <div class="imagebox-caption">{{ image.name }}</div>
          </figcaption>
        </figure>
      </li>
    </ul>
    <PhotoSwipeOverlay />
  </div>
</template>

<script>
import PhotoSwipeOverlay from '@/components/PhotoSwipeOverlay.vue'
import initPhotoSwipeFromDOM from '@/utils/photo-swipe'
import UploadImage from '@/utils/UploadImage'

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },

  components: {
    PhotoSwipeOverlay
  },

  metaInfo() {
    return {
      link: [
        { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.3/photoswipe.min.css' },
        { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.3/default-skin/default-skin.min.css' }
      ]
    }
  },

  data() {
    return {
      images: []
    }
  },

  mounted() {
    initPhotoSwipeFromDOM(this.$refs.images)
  },

  watch: {
    items: {
      handler(val) {
        this.images = val.map(v => new UploadImage({
          id: v.answer_image_id,
          name: v.image_name,
          width: v.image_width,
          height: v.image_height,
          signedUrl: v.signed_url
        }))
      },
      immediate: true
    }
  }
}
</script>
